import React from "react";
import MappReviewView from "../components/mappReviewView";
import '../css/review.css'
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import { withCreateReview } from "./reviewOperations";
import { message } from "antd";
const MappReviewContainer = (props) => {
    const { me, createReview, closeReview, navigateRoute, postReviewNavigateUrl, setPostReviewNavigateUrl, setReviewModule } = props
    const onSubmitReview = async (data) => {
        let reviewData = {
            submittedBy: me?.id,
            module: data?.module?.toLowerCase(),
            rating: data?.rating,
            additionalFeedback: data?.comment
        }
        try {
            const response = await createReview({ reviewData: [reviewData] })
            if (response[0]?.id) {
                message.success("Thanks for the feedback")
                closeReview(postReviewNavigateUrl)
            } else {
                console.error("Error while submitting review")
                closeReview(postReviewNavigateUrl)
            }
        }
        catch (e) {
            console.error("Error while submitting review", e)
            localStorage.removeItem('review_module')
            navigateRoute(postReviewNavigateUrl)
            setPostReviewNavigateUrl(null)
            setReviewModule(null)
        }
    }
    return (
        <>
            <MappReviewView
                onSubmitReview={(value) => onSubmitReview(value)}
                {...props}
            />
        </>
    )
}

export default compose(withApollo, withCreateReview)(MappReviewContainer);